module.exports = __webpack_public_path__ + "img/white.d443775f.png";